import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_MESSAGES_SUCCESS,
  MODIFY_MESSAGE_SUCCESS,
  UPLOAD_IMAGE_SUCCESS,
  IMAGE_UPLOADING_SUCCESS,
  FETCH_GOALS_SUCCESS,
  UPDATE_GOAL_SUCCESS,
  SET_GOALS_LOADING,
  SET_MESSAGES_LOADING,
  UPDATE_THEME_PREFERENCES_SUCCESS,
  UPDATE_THEME_SUCCESS,
  FETCH_NOTIFICATION_SUCCESS
} from "../sagas/userMenu/userMenu";

export const actionCreators = {};

export const initialState = {
  currentUser: {
    sendDesktopNotifications: true
  },
  lightTheme: false,
  messages: [],
  notification: {},
  unreadMessages: 0,
  isLoading: true,
  imageUploading: false,
  goalsLoading: true,
  intialGoalsLoading: true,
  messagesLoading: true,
  goals: []
};

function getUnread(data) {
  let unread = 0;
  // console.log('messages data', data)
  if (data !== undefined) {
    data.map((item) => {
      if (!item.read) {
        unread++;
      }
    });
    return unread;
  } else {
    return unread;
  }
}

export default handleActions(
  {
    [IMAGE_UPLOADING_SUCCESS]: (state, action) => ({
      ...state,
      imageUploading: action.payload.payload
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload || state.isLoading
    }),
    [SET_GOALS_LOADING]: (state, action) => ({
      ...state,
      goalsLoading: action.payload || state.goalsLoading
    }),
    [SET_MESSAGES_LOADING]: (state, action) => ({
      ...state,
      messagesLoading: action.payload || state.messagesLoading
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      lightTheme: action.payload.theme !== "dark"
    }),
    [FETCH_MESSAGES_SUCCESS]: (state, action) => ({
      ...state,
      messages: action !== undefined ? action.payload.messages || state.messages : state.messages,
      unreadMessages: getUnread(action.payload.messages),
      messagesLoading: false
    }),
    [FETCH_NOTIFICATION_SUCCESS]: (state, action) => {
      return {
        ...state,
        notification: action.payload
      };
    },
    [FETCH_GOALS_SUCCESS]: (state, action) => ({
      ...state,
      goals: action.payload.goals || state.goals,
      intialGoalsLoading: false,
      goalsLoading: false
    }),
    [UPDATE_GOAL_SUCCESS]: (state, action) => ({
      ...state,
      goals: action.payload.goals || state.goals,
      goalsLoading: false
    }),
    [MODIFY_MESSAGE_SUCCESS]: (state, action) => ({
      ...state,
      messages: action.payload.messages || state.messages,
      unreadMessages: getUnread(action.payload.messages),
      messagesLoading: false
    }),
    [UPLOAD_IMAGE_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      imageUploading: false
    }),
    [UPDATE_THEME_SUCCESS]: (state, action) => ({
      ...state,
      lightTheme: action.payload.theme !== "dark"
    }),
    [UPDATE_THEME_PREFERENCES_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      lightTheme: action.payload.theme !== "dark"
    })
  },
  initialState
);
